/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-20.
 * Local helpers for this component.
 */
import { isEmpty } from 'lodash';
import { feeTax } from '../../app.config';

const validServiceFilter = (item) =>
    !isEmpty(item.invoiceItem) && item.priceValue > 0 && item.numberOfItems > 0;

const validExpenseFilter = (item) => !isEmpty(item.invoiceItem) && item.amount > 0;

export const buildPreInvoiceObject = (
    servicesTotals,
    preInvoiceType,
    totals,
    advancePayment,
    id,
    services,
    expenses,
    fee,
    feeAmount,
    userId,
    coin
) => {
    const {
        subtotal: servicesSubtotal,
        tax,
        aditionalTax,
        retentions,
        total: servicesTotal
    } = servicesTotals;
    const {
        //customHouse, custom house values
        expensesTotal,
        subtotal,
        balance
    } = totals;

    const servicesItems = services
        .filter(validServiceFilter)
        .map(item => ({
            conceptDescription: item.invoiceItem.concept || '',
            applicable: item.invoiceItem.applicableRepresentation || '',
            unitaryPrice: item.priceValue || 0,
            quantity: item.numberOfItems || 0,
            importAmount: (item.priceValue || 0) * (item.numberOfItems || 0),
            taxAmount: item.invoiceItem.tax || 0,
            aditionalTaxAmount: item.invoiceItem.aditionalTax || 0,
            conceptType: 'Servicio'
        }));

    const expensesItems = expenses
        .filter(validExpenseFilter)
        .map(item => ({
            conceptDescription: item.invoiceItem.concept || '',
            applicable: item.invoiceItem.applicableRepresentation || '',
            unitaryPrice: item.amount || 0,
            quantity: 1,
            importAmount: (item.amount || 0) * 1,
            taxAmount: item.invoiceItem.tax || 0,
            aditionalTaxAmount: item.invoiceItem.aditionalTax || 0,
            conceptType: 'Gasto'
        }));

    const complementaryItem = {
        conceptDescription: 'COMPLEMENTARIOS',
        applicable: 'N/A',
        unitaryPrice: fee.complementary || 0,
        quantity: 1,
        importAmount: fee.complementary,
        taxAmount: feeTax,
        aditionalTaxAmount: 0,
        conceptType: ''
    };

    const flatItem = {
        conceptDescription: 'Tarifa FLAT',
        applicable: 'N/A',
        unitaryPrice: fee.flatValue || 0,
        quantity: 1,
        importAmount: fee.flatValue,
        taxAmount: feeTax,
        aditionalTaxAmount: 0,
        conceptType: ''
    };

    const feeItem = {
        conceptDescription: 'HONORARIOS',
        applicable: `${fee.feeValue} %`,
        unitaryPrice: feeAmount / fee.numberOfItems,
        quantity: fee.numberOfItems,
        importAmount: feeAmount,
        taxAmount: feeTax,
        aditionalTaxAmount: 0,
        conceptType: ''
    };

    const usingTabular = preInvoiceType === '1' || preInvoiceType === '2';
    const preInvoiceItemList = [
        usingTabular && flatItem,
        usingTabular && complementaryItem,
        ...servicesItems,
        ...expensesItems,
        usingTabular && feeItem
    ].filter(concept => concept);

    return {
        servicesSubtotal,
        tax,
        aditionalTax,
        retentions,
        servicesTotal,
        expensesTotal,
        subtotal,
        advancePayment,
        balance,
        preInvoiceType,
        customsClearence: { id },
        preInvoiceItemList,
        userId,
        currency: coin
    };
};

export const getServicesTotals = (preInvoiceTypeConfig, services, fee, feeAmount = 0) => {
    const configNotValid = isEmpty(preInvoiceTypeConfig);

    return {
        subtotal: configNotValid ? 0 : preInvoiceTypeConfig.getSubtotal(services, feeAmount, fee),
        tax: configNotValid ? 0 : preInvoiceTypeConfig.getTax(services, feeAmount, fee),
        aditionalTax: configNotValid ? 0 : preInvoiceTypeConfig.getAditionalTax(services),
        retentions: configNotValid ? 0 : preInvoiceTypeConfig.getRetentions(services),
        total: configNotValid ? 0 : preInvoiceTypeConfig.getTotal(services, feeAmount, fee)
    };
};

export const getFeeAmount = (preInvoiceTypeConfig, expenses, fee) => {
    const configNotValid = isEmpty(preInvoiceTypeConfig);
    return configNotValid ? 0 : Number(preInvoiceTypeConfig.getFee(expenses, fee.feeValue, fee.customHouseValue, fee.minFee, fee.numberOfItems));
};

export const getExpensesTotal = (preInvoiceTypeConfig, expenses) => {
    const configNotValid = isEmpty(preInvoiceTypeConfig);
    return configNotValid ? 0 : Number(preInvoiceTypeConfig.getExpenseRatio(expenses));
};

export const getTotals = (servicesTotals, expensesTotal, advancePayment) => ({
    customHouse: Number(servicesTotals.total),
    expensesTotal: Number(expensesTotal),
    subtotal: Number(servicesTotals.total + expensesTotal),
    balance: Number((servicesTotals.total + expensesTotal) - advancePayment)
});

export const isPreinvoiceValid = (services, expenses) => {
    const validItems = [
        ...services.filter(validServiceFilter),
        ...expenses.filter(validExpenseFilter)
    ];

    return validItems.length > 0;
};



// WEBPACK FOOTER //
// ./forms/customPrefactura/helpers.js